import { ACTION_TYPES, usePrestacaoContasTiposDispatch } from "./prestacao-contas-tipos-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";

export const usePrestacaoContasTiposController = () => {
    const dispatch = usePrestacaoContasTiposDispatch();

    async function onInit() {
        try {
            dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            const tipos = await MunicipalPortalAAppService.listTiposDocumentoPrestacaoContas();
            dispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
        } catch (error) {
            console.log(error);
        } finally {
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
        }
    }

    return { onInit };
}
